import { useMutation } from '@tanstack/react-query';

import { locationApi } from '@/api/routes/common/location.api';

/** The caller shows the lookup error next to the CEP field, so the global snackbar stays quiet. */
export const useGetAddressByPostalCode = () =>
  useMutation({
    mutationFn: (postalCode: string) =>
      locationApi.getAddressByPostalCode(postalCode).then((response) => response.data),
    meta: { showUserMessage: false },
  });
